import { render, staticRenderFns } from "./RelatorioFaturamento.vue?vue&type=template&id=33ed971b&"
import script from "./RelatorioFaturamento.vue?vue&type=script&lang=js&"
export * from "./RelatorioFaturamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports